import React from 'react';

import S3_URI from './config';

export const classificacoes = [
  { value: 'L', label: 'L', id: 1 },
  { value: '10', label: '10', id: 2 },
  { value: '12', label: '12', id: 3 },
  { value: '14', label: '14', id: 4 },
  { value: '16', label: '16', id: 5 },
  { value: '18', label: '18', id: 6 },
  { value: 'ER', label: 'ER', id: 7 },
];

export const status = [
  { value: 0, label: 'Não' },
  { value: 1, label: 'Não OK' },
  { value: 2, label: 'Fest' },
  {
    value: 3,
    label: 'Convidado OK',
  },
  { value: 4, label: 'Convidado' },
  { value: 5, label: 'Inscrito PB' },
  { value: 6, label: 'Inscrito CI' },
];

export const statusAssessments = [
  { value: 0, label: 'Para ver', class: 'warning' },
  { value: 1, label: 'Visto', class: 'success' },
];

export const statusGuestCredentials = [
  { value: 0, label: 'Pendente', class: 'warning' },
  { value: 1, label: 'Confirmado', class: 'success' },
  { value: 2, label: 'Convidado', class: 'info' },
  { value: 3, label: 'Em negociação', class: 'primary' },
  { value: 4, label: 'Cancelado', class: 'secondary' },
  { value: 5, label: 'Não aprovado', class: 'danger' },
];

export const guestTravelPackages = [
  { value: 0, label: 'Não se aplica' },
  { value: 1, label: 'Passagem + hospedagem' },
  { value: 2, label: 'Passagem' },
  { value: 3, label: 'Hospedagem' },
];

export const assessmentsRecomendations = [
  { value: 0, label: 'Pendente', class: 'warning' },
  { value: 1, label: 'Não', class: 'danger' },
  { value: 2, label: 'Dispensável', class: 'secondary' },
  { value: 3, label: 'Exibível', class: 'info' },
  { value: 4, label: 'Merece', class: 'primary' },
  { value: 5, label: 'Deve', class: 'success' },
];

/**
 * Padrão de cores dos status, usado tanto nos radios (icheck, via `class`)
 * quanto nas labels das listagens (bootstrap, via `badge-pill`):
 *
 *   Pendente / Não solicitado ....... amarelo  yellow / bg-warning
 *   Solicitado ...................... cinza    grey   / bg-secondary
 *   Recebido / Encaminhado .......... azul     blue   / bg-info
 *   Aprovado / Finalizado / Pago .... verde    green  / bg-success
 *   Liberado ........................ laranja  orange / bg-primary
 *   Reprovado ....................... vermelho red    / bg-danger
 *
 * Ao criar uma nova lista de status, siga essa tabela.
 */
export const listaStatusCopia = [
  {
    value: 0,
    label: 'Não solicitada',
    class: 'yellow',
    badge: 'badge-pill bg-warning',
    id: 'status_copia_nao_solicitada',
  },
  {
    value: 1,
    label: 'Solicitada',
    class: 'grey',
    badge: 'badge-pill bg-secondary',
    id: 'status_copia_solicitada',
  },
  {
    value: 2,
    label: 'Recebida',
    class: 'blue',
    badge: 'badge-pill bg-info',
    id: 'status_copia_recebida',
  },
  {
    value: 3,
    label: 'Aprovada',
    class: 'green',
    badge: 'badge-pill bg-success',
    id: 'status_copia_aprovada',
  },
  {
    value: 4,
    label: 'Reprovada',
    class: 'red',
    badge: 'badge-pill bg-danger',
    id: 'status_copia_reprovada',
  },
];

export const bitolas = [
  { value: 'DCP Aberto', label: 'DCP Aberto' },
  { value: 'DCP + KDM', label: 'DCP + KDM' },
  { value: '16mm', label: '16mm' },
  { value: '35mm', label: '35mm' },
  { value: 'Outros formatos', label: 'Outros formatos' },
];

export const origens_copia = [
  { value: 'DCP Download', label: 'DCP Download' },
  { value: 'Mídia Física', label: 'Mídia Física' },
];

export const legendas_copia = [
  { value: 'Português', label: 'Português' },
  { value: 'Inglês', label: 'Inglês' },
  { value: 'Francês', label: 'Francês' },
  { value: 'Espanhol', label: 'Espanhol' },
  { value: 'Outra', label: 'Outra' },
  { value: 'Sem legenda', label: 'Sem legenda' },
];

export const legendas_exibicao = [
  { value: 'Eletrônica em Português', label: 'Eletrônica em Português' },
  { value: 'Eletrônica em Inglês', label: 'Eletrônica em Inglês' },
  { value: 'Português', label: 'Português' },
  { value: 'Inglês', label: 'Inglês' },
  { value: 'Outra', label: 'Outra' },
  { value: 'Sem legenda', label: 'Sem legenda' },
];

export const cores = [
  { value: 'Cor', label: 'Cor' },
  { value: 'P&B', label: 'P&B' },
  { value: 'Cor & P&B', label: 'Cor & P&B' },
];

export const fps = [
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '60', label: '60' },
  { value: '120', label: '120' },
  { value: '29.97', label: '29.97' },
  { value: '23.98', label: '23.98' },
];

export const janelas = [
  { value: '2.39 (DCP scope)', label: '2.39 (DCP scope)' },
  { value: '1.85 (DCP flat)', label: '1.85 (DCP flat)' },
  { value: '1.90 (DCP full)', label: '1.90 (DCP full)' },
];

export const resolucoes = [
  { value: '4K (4096x2160)', label: '4K (4096x2160)' },
  { value: '2K (2048x1080)', label: '2K (2048x1080)' },
];

export const sons = [
  { value: 'Dolby Atmos', label: 'Dolby Atmos' },
  { value: 'Barco Auro3D 11.1', label: 'Barco Auro3D 11.1' },
  { value: 'Dolby Digital EX 7.1', label: 'Dolby Digital EX 7.1' },
  { value: 'Dolby Digital EX 6.1', label: 'Dolby Digital EX 6.1' },
  { value: 'Digital 5.1', label: 'Digital 5.1' },
  { value: 'Stereo 2.0', label: 'Stereo 2.0' },
  { value: 'Mono 1.0', label: 'Mono 1.0' },
  { value: 'Mudo', label: 'Mudo' },
];

export const volumes = [
  { value: 'Padrão', label: 'Padrão' },
  { value: 'Aumentar', label: 'Aumentar' },
  { value: 'Abaixar', label: 'Abaixar' },
];

export const sessoes = [
  { value: 'sessao_gala', label: 'Gala' },
  { value: 'sessao_debate', label: 'Debate' },
  { value: 'sessao_especial', label: 'Sessão Especial' },
];

/**
 * Distribuidora atribuída que vale para uma sessão. É a mesma regra em todas
 * as telas e exportações, e também no filtro da listagem de sessões da API:
 * - filme sem distribuidora atribuída: nenhuma;
 * - filme com uma só: a do filme, sem precisar escolher na sessão;
 * - filme com mais de uma: a escolhida para a sessão, desde que ainda seja
 *   uma das do filme; sem escolha, nenhuma.
 *
 * `movie` é opcional: serve quando a sessão não traz o filme embutido, como
 * nas sessões que vêm dentro do próprio filme.
 */
export const getScheduleAssignedDistributor = (
  schedule,
  movie = schedule?.movie,
) => {
  const doFilme = movie?.assigned_distributors || [];

  if (doFilme.length === 1) {
    return doFilme[0];
  }

  return (
    doFilme.find(ad => ad.id === Number(schedule?.assigned_distributor_id)) ||
    null
  );
};

export const getScheduleAssignedDistributorName = (schedule, movie) =>
  getScheduleAssignedDistributor(schedule, movie)?.name || '';

/**
 * Escreve as sessões especiais marcadas na sessão, separadas por vírgula, na
 * ordem Gala, Debate, Sessão Especial. Volta vazio quando a sessão não é nenhuma
 * delas.
 */
export const sessoesEspeciais = schedule => {
  const marcadas = [];

  if (Number(schedule?.sessao_gala) === 1) {
    marcadas.push('Gala');
  }

  if (Number(schedule?.sessao_debate) === 1) {
    marcadas.push('Debate');
  }

  if (Number(schedule?.sessao_especial) === 1) {
    marcadas.push('Sessão Especial');
  }

  return marcadas.join(', ');
};

export const status_kdm = [
  {
    value: 0,
    label: 'Não solicitado',
    class: 'yellow',
    badge: 'badge-pill bg-warning',
    id: 'status_copia_nao_solicitado',
  },
  {
    value: 1,
    label: 'Solicitado',
    class: 'grey',
    badge: 'badge-pill bg-secondary',
    id: 'status_copia_solicitado',
  },
  {
    value: 2,
    label: 'Recebido',
    class: 'blue',
    badge: 'badge-pill bg-info',
    id: 'status_copia_recebido',
  },
  {
    value: 3,
    label: 'Aprovado',
    class: 'green',
    badge: 'badge-pill bg-success',
    id: 'status_copia_aprovado',
  },
  {
    value: 4,
    label: 'Reprovado',
    class: 'red',
    badge: 'badge-pill bg-danger',
    id: 'status_copia_reprovado',
  },
];

export const listaStatusLegenda = [
  {
    value: 0,
    label: 'Pendente',
    class: 'yellow',
    badge: 'badge-pill bg-warning',
    id: 'status_legendagem_pendente',
  },
  {
    value: 1,
    label: 'Encaminhada',
    class: 'blue',
    badge: 'badge-pill bg-info',
    id: 'status_legendagem_encaminhada',
  },
  {
    value: 2,
    label: 'Finalizada',
    class: 'green',
    badge: 'badge-pill bg-success',
    id: 'status_legendagem_finalizada',
  },
];

export const statusRevisao = [
  { value: 'Pendente', label: 'Pendente', id: 11 },
  { value: 'CI/PB preenchido', label: 'CI/PB preenchido', id: 12 },
  { value: 'Redator', label: 'Redator', id: 1 },
  { value: 'Editor 1', label: 'Editor 1', id: 2 },
  { value: 'Tradutor', label: 'Tradutor', id: 3 },
  {
    value: 'Editor 2',
    label: 'Editor 2',
    id: 4,
  },
  { value: 'Revisor português', label: 'Revisor português', id: 5 },
  { value: 'Revisor inglês', label: 'Revisor inglês', id: 6 },
  { value: 'Editor 3', label: 'Editor 3', id: 7 },
  { value: 'CI/PB revisado', label: 'CI/PB revisado', id: 8 },
  { value: 'Editor 4', label: 'Editor 4', id: 9 },
  { value: 'Designer', label: 'Designer', id: 10 },
];

export const statusSelecoes = [
  { value: 'todos', label: 'Todos' },
  { value: 'pendente', label: 'Pendente' },
];

export const distributorCategories = [
  { value: 'Nacional', label: 'Nacional' },
  { value: 'Internacional', label: 'Internacional' },
];

export const listaCostsInvoiceStatus = [
  {
    value: 0,
    label: 'Não Solicitado',
    class: 'yellow',
    badge: 'badge-pill bg-warning',
    id: 'costs_status_invoice_nao_solicitado',
  },
  {
    value: 4,
    label: 'Solicitado',
    class: 'grey',
    badge: 'badge-pill bg-secondary',
    id: 'costs_status_invoice_solicitado',
  },
  {
    value: 1,
    label: 'Recebido',
    class: 'blue',
    badge: 'badge-pill bg-info',
    id: 'costs_status_invoice_recebido',
  },
  {
    value: 2,
    label: 'Encaminhado',
    class: 'blue',
    badge: 'badge-pill bg-info',
    id: 'costs_status_invoice_encaminhado',
  },
  {
    value: 3,
    label: 'Pago',
    class: 'green',
    badge: 'badge-pill bg-success',
    id: 'costs_status_invoice_pago',
  },
];

export const movieSorting = [
  {
    label: 'Filme',
    value: 'filme',
    id: 1,
    data: { direction: 'asc' },
  },
  {
    label: 'Título em português sem artigo',
    value: 'titulo_em_portugues_s_artigo',
    id: 2,
    data: { direction: 'asc' },
  },
  {
    label: 'Título em inglês sem artigo',
    value: 'titulo_em_ingles_s_artigo',
    id: 3,
    data: { direction: 'asc' },
  },
  {
    label: 'Título original sem artigo',
    value: 'titulo_original_s_artigo',
    id: 4,
    data: { direction: 'asc' },
  },
  {
    label: 'Minutagem ASC',
    value: 'duracao_asc',
    id: 5,
    data: { direction: 'asc' },
  },
  {
    label: 'Minutagem DESC',
    value: 'duracao_desc',
    id: 6,
    data: { direction: 'desc' },
  },
  {
    label: 'Sequência Película',
    value: 'seq_pelicula',
    id: 7,
    data: { direction: 'asc' },
  },
];

export const screenerSorting = [
  {
    label: 'Filme',
    value: 'movies.filme',
    id: 1,
    data: { direction: 'asc' },
  },
  {
    label: 'Status',
    value: 'status',
    id: 2,
    data: { direction: 'asc' },
  },
  {
    label: 'Selo',
    value: 'recomendation',
    id: 3,
    data: { direction: 'asc' },
  },
  // {
  //   label: 'Print Source',
  //   value: 'movie.distributors.name',
  //   id: 4,
  //   data: { direction: 'asc' },
  // },
  {
    label: 'Responsável',
    value: 'users.name',
    id: 5,
    data: { direction: 'asc' },
  },
];

export const scheduleSorting = [
  {
    label: 'Dia e Sessão crescentes',
    value: 'session_date_time_asc',
  },
  {
    label: 'Dia e Sessão decrescentes',
    value: 'session_date_time_desc',
  },
  {
    label: 'Cinema, dia e sessao',
    value: 'cinema_dia_sessao_asc',
  },
  {
    label: 'Minutagem crescente',
    value: 'duracao_asc',
  },
  {
    label: 'Minutagem decrescente',
    value: 'duracao_desc',
  },
  {
    label: 'Filme crescente',
    value: 'filme_asc',
  },
  {
    label: 'Título em português sem artigo crescente',
    value: 'titulo_portugues_sem_artigo_asc',
  },
  {
    label: 'Sessão, data, cinema',
    value: 'sessao_data_cinema_asc',
  },
  {
    label: 'Filme, data',
    value: 'filme_data_asc',
  },
  {
    label: 'Filme, cinema',
    value: 'filme_cinema_asc',
  },
];

export const scheduleCostsSorting = [
  {
    label: 'Dia e Sessão crescentes',
    value: 'session_date_time_asc',
  },
  {
    label: 'Dia e Sessão decrescentes',
    value: 'session_date_time_desc',
  },
  {
    label: 'Cinema, dia e sessao',
    value: 'cinema_dia_sessao_asc',
  },
  {
    label: 'Minutagem crescente',
    value: 'duracao_asc',
  },
  {
    label: 'Minutagem decrescente',
    value: 'duracao_desc',
  },
  {
    label: 'Filme crescente',
    value: 'filme_asc',
  },
  {
    label: 'Título em português sem artigo crescente',
    value: 'titulo_portugues_sem_artigo_asc',
  },
  {
    label: 'Sessão, data, cinema',
    value: 'sessao_data_cinema_asc',
  },
  {
    label: 'Filme, data',
    value: 'filme_data_asc',
  },
  {
    label: 'Filme, cinema',
    value: 'filme_cinema_asc',
  },
  {
    label: 'Rendas crescentes',
    value: 'renda_total_asc',
  },
  {
    label: 'Rendas decrescentes',
    value: 'renda_total_desc',
  },
  {
    label: 'Público pagante crescente',
    value: 'publico_pagante_asc',
  },
  {
    label: 'Público pagante decrescente',
    value: 'publico_pagante_desc',
  },
  {
    label: 'Público geral crescente',
    value: 'publico_total_asc',
  },
  {
    label: 'Público geral decrescente',
    value: 'publico_total_desc',
  },
];

export const listaStatusGuestCredentials = [
  {
    value: 0,
    label: 'Pendente',
    class: 'yellow',
    id: 'status_guest_pendente',
  },
  {
    value: 1,
    label: 'Confirmado',
    class: 'green',
    id: 'status_guest_confirmado',
  },
  {
    value: 2,
    label: 'Convidado',
    class: 'blue',
    id: 'status_guest_convidado',
  },
  {
    value: 3,
    label: 'Em negociação',
    class: 'orange',
    id: 'status_guest_em_negociacao',
  },
  {
    value: 4,
    label: 'Cancelado',
    class: 'gray',
    id: 'status_guest_cancelado',
  },
  {
    value: 5,
    label: 'Não aprovado',
    class: 'red',
    id: 'status_guest_nao_aprovado',
  },
];

export const listaStatusMovieMaterials = [
  {
    value: 0,
    label: 'Pendente',
    class: 'yellow',
    badge: 'badge-pill bg-warning',
    id: 'status_stills_pending',
  },
  {
    value: 1,
    label: 'Solicitado',
    class: 'grey',
    badge: 'badge-pill bg-secondary',
    id: 'status_stills_requested',
  },
  {
    value: 2,
    label: 'Recebido',
    class: 'blue',
    badge: 'badge-pill bg-info',
    id: 'status_stills_received',
  },
  {
    value: 3,
    label: 'Aprovado',
    class: 'green',
    badge: 'badge-pill bg-success',
    id: 'status_stills_approved',
  },
  {
    value: 4,
    label: 'Liberado',
    class: 'orange',
    badge: 'badge-pill bg-primary',
    id: 'status_stills_released',
  },
];

export const guestConditions = [
  { value: 'guest', label: 'Convidado' },
  { value: 'companion', label: 'Acompanhante' },
];

export const guestConditionsValues = [
  { value: 1, label: 'Convidado' },
  { value: 2, label: 'Acompanhante' },
];

export const guestPronouns = [
  { value: 1, label: 'Ele/Dele|He/Him' },
  { value: 2, label: 'Ela/Dela|She/Her' },
  { value: 3, label: 'Elu/Delu|They/Them' },
];

// "do Adriano", "da Maria", "de Alex": primeiro nome com a preposição do
// pronome da ficha (Elu ou sem pronome: "de", a forma neutra). Sem nome, null.
export const guestOfName = guest => {
  const firstName = (guest?.name || '').trim().split(/\s+/)[0];
  if (!firstName) return null;
  const preposition = { 1: 'do', 2: 'da' }[Number(guest.pronoun)] || 'de';
  return `${preposition} ${firstName}`;
};

export const guestVisaStatus = [
  { value: 0, label: 'Sem necessidade' },
  { value: 1, label: 'Necessário' },
  { value: 2, label: 'Em processo' },
  { value: 3, label: 'Confirmado' },
];

export const guestVisaStatusSearch = [
  { value: 1, label: 'Sem necessidade' },
  { value: 2, label: 'Necessário' },
  { value: 3, label: 'Em processo' },
  { value: 4, label: 'Confirmado' },
];

export const guestAddressTypes = [
  { value: 1, label: 'Referência' },
  { value: 2, label: 'Representante' },
  { value: 3, label: 'Endereço para envio' },
];

export const guestDocumentTypes = [
  { value: 1, label: 'Passaporte' },
  { value: 2, label: 'Carteira de Identidade' },
  { value: 3, label: 'CNH' },
];

export const guestAccomodationTypes = [
  { value: 1, label: 'Single' },
  { value: 2, label: 'Duplo' },
  { value: 3, label: 'Triplo' },
  { value: 4, label: 'Casal' },
];

export const guestAccomodationStatus = [
  { value: 1, label: 'Não confirmado' },
  { value: 2, label: 'Confirmado' },
];

export const accommodationSorting = [
  {
    label: 'Nome Convidado',
    value: 'guests.name',
    id: 1,
    data: { direction: 'asc' },
  },
  {
    label: 'Nome Hotel',
    value: 'hotels.name',
    id: 2,
    data: { direction: 'asc' },
  },
  {
    label: 'Data Check-in',
    value: 'guest_accommodations.check_in',
    id: 3,
    data: { direction: 'asc' },
  },
  {
    label: 'Data Check-out',
    value: 'guest_accommodations.check_out',
    id: 4,
    data: { direction: 'asc' },
  },
];

export const travelSorting = [
  {
    label: 'Nome Convidado',
    value: 'guests.name',
    id: 1,
    data: { direction: 'asc' },
  },
  {
    label: 'Nome cia aérea',
    value: 'guest_travels.arriving_airline',
    id: 2,
    data: { direction: 'asc' },
  },
  {
    label: 'Data chegada',
    value: 'guest_travels.arrival_time',
    id: 3,
    data: { direction: 'asc' },
  },
  {
    label: 'Data partida',
    value: 'guest_travels.departure_airline',
    id: 4,
    data: { direction: 'asc' },
  },
];

export const generalYesNoList = [
  { value: 0, label: 'Não' },
  { value: 1, label: 'Sim' },
];

// A ficha grava o que está em isCredentialDeliveredList: 2 = entregue, 1 = não;
// 0 = nunca salvo (também não entregue)
export const CREDENTIAL_DELIVERED = 2;
export const isCredentialDelivered = credential =>
  Number(credential?.is_credential_delivered) === CREDENTIAL_DELIVERED;

export const isCredentialDeliveredList = [
  { value: 2, label: 'Sim', id: 'credential-delivered-yes', class: 'green' },
  { value: 1, label: 'Não', id: 'credential-delivered-no', class: 'red' },
];

export const canRequestTicketsList = [
  { value: 1, label: 'Sim', id: 'can-request-tickets-yes', class: 'green' },
  { value: 0, label: 'Não', id: 'can-request-tickets-no', class: 'red' },
];

// Filtro "Ingressos" das listagens: 2 = Sim, 1 = Não (a API subtrai 1, como
// no filtro de credencial entregue)
export const canRequestTicketsFilterList = [
  { value: 2, label: 'Sim' },
  { value: 1, label: 'Não' },
];

// "Precisa de inscrição?" da sessão Gratuita (AddScheduleModal e
// EditScheduleFromListModal)
export const precisaInscricaoList = [
  { value: 1, label: 'Sim', id: 'precisa-inscricao-sim', class: 'green' },
  { value: 0, label: 'Não', id: 'precisa-inscricao-nao', class: 'red' },
];

export const isAccomodationEarlyCheckInList = [
  {
    value: 1,
    label: 'Sim',
    id: 'accomodation-early-checkin-yes',
    class: 'green',
  },
  { value: 0, label: 'Não', id: 'accomodation-early-checkin-no', class: 'red' },
];

export const isAccomodationEarlyCheckOutList = [
  {
    value: 1,
    label: 'Sim',
    id: 'accomodation-early-checkout-yes',
    class: 'green',
  },
  {
    value: 0,
    label: 'Não',
    id: 'accomodation-early-checkout-no',
    class: 'red',
  },
];

export const isDirectFlightList = [
  {
    value: 1,
    label: 'Sim',
    id: 'travel-direct-flight-yes',
    class: 'green',
  },
  {
    value: 0,
    label: 'Não',
    id: 'travel-direct-flight-no',
    class: 'red',
  },
];

export const isDepartureDirectFlightList = [
  {
    value: 1,
    label: 'Sim',
    id: 'travel-departure-direct-flight-yes',
    class: 'green',
  },
  {
    value: 0,
    label: 'Não',
    id: 'travel-departure-direct-flight-no',
    class: 'red',
  },
];

export const hasArrivalTransferList = [
  {
    value: 1,
    label: 'Sim',
    id: 'travel-has-arrival-transfer-yes',
    class: 'green',
  },
  {
    value: 0,
    label: 'Não',
    id: 'travel-has-arrival-transfer-no',
    class: 'red',
  },
];

export const hasDepartureTransferList = [
  {
    value: 1,
    label: 'Sim',
    id: 'travel-has-departure-transfer-yes',
    class: 'green',
  },
  {
    value: 0,
    label: 'Não',
    id: 'travel-has-departure-transfer-no',
    class: 'red',
  },
];

export const guestTravelTypes = [
  { value: 1, label: 'Ida e Volta' },
  { value: 2, label: 'Somente Ida' },
  { value: 3, label: 'Somente Volta' },
];

export const guestTravelPayers = [
  { value: 1, label: 'Festival' },
  { value: 2, label: 'ETC' },
  { value: 3, label: 'Festival + ETC' },
];

export const moedas = [
  { value: 1, label: 'Real' },
  { value: 2, label: 'Dolar' },
  { value: 3, label: 'Euro' },
  { value: 4, label: 'Libra' },
];

export const guestTravelFlightClass = [
  { value: 1, label: 'Econômica' },
  { value: 2, label: 'Econômica Plus' },
  { value: 3, label: 'Executiva' },
];

export const travelTicketStatusList = [
  {
    value: 1,
    label: 'Emitida',
    id: 'travel-ticket-status-yes',
    class: 'green',
  },
  {
    value: 0,
    label: 'Não emitida',
    id: 'travel-ticket-status-no',
    class: 'red',
  },
];

export const travelTicketStatus = [
  {
    value: 2,
    label: 'Emitida',
  },
  {
    value: 1,
    label: 'Não emitida',
  },
];

export const currencies = [
  { value: 'Dólar', label: 'Dólar' },
  { value: 'Euro', label: 'Euro' },
  { value: 'Libra', label: 'Libra' },
];

export const gendersList = [
  { value: 'Homem', label: 'Homem' },
  { value: 'Mulher', label: 'Mulher' },
  { value: 'Não binário', label: 'Não binário' },
  { value: 'Não informado', label: 'Não informado' },
];

export const guestConditionsList = [
  { value: 'Homem', label: 'Homem' },
  { value: 'Mulher', label: 'Mulher' },
  { value: 'Não binário', label: 'Não binário' },
  { value: 'Não informado', label: 'Não informado' },
];

export const states = [
  { value: 'AC', label: 'Acre', data: { name: 'Acre' } },
  { value: 'AL', label: 'Alagoas', data: { name: 'Alagoas' } },
  { value: 'AP', label: 'Amapá', data: { name: 'Amapa' } },
  { value: 'AM', label: 'Amazonas', data: { name: 'Amazonas' } },
  { value: 'BA', label: 'Bahia', data: { name: 'Bahia' } },
  { value: 'CE', label: 'Ceará', data: { name: 'Ceara' } },
  {
    value: 'DF',
    label: 'Distrito Federal',
    data: { name: 'Distrito Federal' },
  },
  { value: 'ES', label: 'Espírito Santo', data: { name: 'Espirito Santo' } },
  { value: 'GO', label: 'Goías', data: { name: 'Goias' } },
  { value: 'MA', label: 'Maranhão', data: { name: 'Maranhao' } },
  { value: 'MT', label: 'Mato Grosso', data: { name: 'Mato Grosso' } },
  {
    value: 'MS',
    label: 'Mato Grosso do Sul',
    data: { name: 'Mato Grosso do Sul' },
  },
  { value: 'MG', label: 'Minas Gerais', data: { name: 'Minas Gerais' } },
  { value: 'PA', label: 'Pará', data: { name: 'Para' } },
  { value: 'PB', label: 'Paraíba', data: { name: 'Paraiba' } },
  { value: 'PR', label: 'Paraná', data: { name: 'Parana' } },
  { value: 'PE', label: 'Pernambuco', data: { name: 'Pernambuco' } },
  { value: 'PI', label: 'Piauí', data: { name: 'Piaui' } },
  { value: 'RJ', label: 'Rio de Janeiro', data: { name: 'Rio de Janeiro' } },
  {
    value: 'RN',
    label: 'Rio Grande do Norte',
    data: { name: 'Rio Grande do Norte' },
  },
  {
    value: 'RS',
    label: 'Rio Grande do Sul',
    data: { name: 'Rio Grande do Sul' },
  },
  { value: 'RO', label: 'Rondônia', data: { name: 'Rondonia' } },
  { value: 'RR', label: 'Roraíma', data: { name: 'Roraima' } },
  { value: 'SC', label: 'Santa Catarina', data: { name: 'Santa Catarina' } },
  { value: 'SP', label: 'São Paulo', data: { name: 'Sao Paulo' } },
  { value: 'SE', label: 'Sergipe', data: { name: 'Sergipe' } },
  { value: 'TO', label: 'Tocantins', data: { name: 'Tocantins' } },
];

/**
 * Label colorida de status, alimentada pelas listas acima.
 *
 * Centraliza o que antes estava duplicado em cada listagem, para que as cores
 * não voltem a divergir entre telas. Se o status não existir na lista, cai no
 * primeiro item, que é sempre o estado inicial (Pendente / Não solicitado).
 */
export function StatusBadge({ lista, value }) {
  const item = lista.find(bd => bd.value === value) || lista[0];

  return <span className={item.badge}>{item.label}</span>;
}

/**
 * Status de programação de uma sessão: cruza o que o filme pede com o que o
 * cinema da sessão oferece. Usado no formulário da película e na listagem de
 * sessões, para que as duas telas apliquem sempre a mesma regra.
 *
 * As explicações de cada erro vieram da equipe do Festival do Rio; os textos
 * abaixo usam os nomes dos campos como aparecem nas telas. Aparecem num balão
 * ao passar o mouse sobre o selo.
 *
 * Se os formatos do cinema não vieram, o Erro 3 não tem como ser avaliado: num
 * filme 3D sem outros erros a célula fica vazia, em vez de afirmar "Ok" ou
 * "Erro 3" sem ter certeza. O status é só informativo e nunca pode quebrar a
 * tela.
 */
const explicacaoErroProgramacao = {
  erro1:
    'O filme tem "Eletrônica em Português" ou "Eletrônica em Inglês" em ' +
    '"Legenda de exibição" e o cinema desta sessão não tem "Legenda ' +
    'Eletrônica" habilitado na Ficha de Cinema.',
  erro2:
    'O filme tem acessibilidade só no DCP em "Suporte de Acessibilidade" e o ' +
    'cinema desta sessão não tem "Acessibilidade no DCP" habilitado na Ficha ' +
    'de Cinema.',
  erro3:
    'O filme tem "Filme 3D" marcado e o cinema desta sessão não tem "DCP 3D" ' +
    'habilitado na Ficha de Cinema.',
};

export function StatusProgramacao({
  legenda_exibicao,
  has_eletronic_subtitle,
  suporte_aplicativo,
  suporte_dcp,
  suporte_nao_possui,
  has_dcp_accessibility,
  movie_3d,
  formats,
}) {
  const errors = [];
  const formatosConhecidos = Array.isArray(formats);

  if (
    !has_eletronic_subtitle &&
    ['Eletrônica em Português', 'Eletrônica em Inglês'].includes(
      legenda_exibicao,
    )
  ) {
    errors.push(
      <span
        key="erro1"
        className="badge-pill bg-danger ml-1"
        title={explicacaoErroProgramacao.erro1}
        style={{ cursor: 'help' }}
      >
        Erro 1
      </span>,
    );
  }

  if (
    !has_dcp_accessibility &&
    !suporte_aplicativo &&
    suporte_dcp &&
    !suporte_nao_possui
  ) {
    errors.push(
      <span
        key="erro2"
        className="badge-pill bg-danger ml-1"
        title={explicacaoErroProgramacao.erro2}
        style={{ cursor: 'help' }}
      >
        Erro 2
      </span>,
    );
  }

  if (movie_3d && formatosConhecidos && !formats.some(f => f.id === 2)) {
    errors.push(
      <span
        key="erro3"
        className="badge-pill bg-danger ml-1"
        title={explicacaoErroProgramacao.erro3}
        style={{ cursor: 'help' }}
      >
        Erro 3
      </span>,
    );
  }

  if (errors.length) {
    return errors;
  }

  if (movie_3d && !formatosConhecidos) {
    return null;
  }

  return <span className="badge-pill bg-success">Ok</span>;
}

/**
 * Identificação da sessão nos avisos de confirmação (excluir, duplicar,
 * remover convidado): data – horário – cinema – filme. Item vazio fica de fora.
 */
export function ScheduleDetails({ schedule }) {
  return (
    <p>
      <strong>
        {[
          schedule.formated_session_date,
          schedule.short_session_time,
          schedule.cinema?.name,
          schedule.movie?.filme,
        ]
          .filter(Boolean)
          .join(' – ')}
      </strong>
    </p>
  );
}

/**
 * Só faz sentido falar em status de KDM quando a bitola é DCP + KDM.
 * Nas demais bitolas a coluna fica vazia, nas listagens e nas exportações.
 */
export const hasKdm = bitolaExibicao => bitolaExibicao === 'DCP + KDM';

/**
 * Foto do diretor: em que pasta do S3 ela está de verdade.
 *
 * A tabela `directors` guarda uma foto só, a mais recente, e ela pode ter sido
 * cadastrada em uma edição anterior à do filme que está sendo editado. Montar a
 * URL sempre com a edição do filme quebra a imagem nesses casos. A API devolve
 * `image_edition` (lida do nome do arquivo); na falta dela, cai na edição do
 * filme, que era o comportamento antigo.
 */
/**
 * Edição do filme, em ano.
 *
 * Nem toda tela carrega a relação `edition` — a listagem do Catálogo, por
 * exemplo, não traz. Mas a seq_pelicula sempre começa com os quatro dígitos do
 * ano da edição, então ela serve de segunda fonte e evita depender de uma
 * relação que pode não vir no payload.
 */
export const getMovieEdition = pelicula => {
  if (pelicula?.edition?.name) {
    return String(pelicula.edition.name);
  }

  const match = String(pelicula?.seq_pelicula || '').match(/^(\d{4})\d+$/);

  return match ? match[1] : null;
};

export const getDirectorImageEdition = (director, pelicula) =>
  director?.image_edition || getMovieEdition(pelicula);

export const getDirectorImageUrl = (director, pelicula, size = 'small') => {
  const edition = getDirectorImageEdition(director, pelicula);

  return `${S3_URI}/${edition}/site/peliculas/${size}/${director.image}`;
};

export const getDirectorImageHdUrl = (director, pelicula) => {
  const edition = getDirectorImageEdition(director, pelicula);

  return `${S3_URI}/${edition}/site/alta/${director.image}`;
};

/**
 * A escolha de reaproveitar a foto só é oferecida quando o diretor tem foto e
 * ela é de uma edição ANTERIOR à do filme. Se a foto for da mesma edição, ou de
 * uma posterior, ela já é a mais recente e é usada direto, sem perguntar nada.
 */
export const hasPreviousEditionPhoto = (director, pelicula) => {
  const photoEdition = Number(director?.image_edition);
  const movieEdition = Number(getMovieEdition(pelicula));

  if (!director?.image || !photoEdition || !movieEdition) {
    return false;
  }

  return photoEdition < movieEdition;
};

/**
 * A foto do diretor deve ser usada nas saídas do filme (ficha, catálogo) quando
 * é da edição do filme ou mais nova, ou quando a equipe autorizou reaproveitar
 * uma foto antiga marcando "Sim" na aba Catálogo.
 */
export const shouldUseDirectorPhoto = (director, pelicula) => {
  if (!director?.image) {
    return false;
  }

  if (!hasPreviousEditionPhoto(director, pelicula)) {
    return true;
  }

  return Boolean(director.pivot?.usa_foto_edicao_anterior);
};

export const getMaxCharsBiografia = pelicula => {
  return pelicula.metragem?.max_chars_biografia;
};

export const getMaxCharsSinopse = pelicula => {
  return pelicula.metragem?.max_chars_sinopse;
};

export const StatusPelicula = props => {
  const statusBadges = [
    { status: 0, badge: <span className="badge-pill bg-danger">Não</span> },
    { status: 1, badge: <span className="badge-pill bg-danger">Não OK</span> },
    { status: 2, badge: <span className="badge-pill bg-success">Fest</span> },
    {
      status: 3,
      badge: <span className="badge-pill bg-primary">Convidado OK</span>,
    },
    {
      status: 4,
      badge: <span className="badge-pill bg-primary">Convidado</span>,
    },
    {
      status: 5,
      badge: <span className="badge-pill bg-warning">Inscrito PB</span>,
    },
    {
      status: 6,
      badge: <span className="badge-pill bg-warning">Inscrito CI</span>,
    },
  ];

  const item = statusBadges.find(bd => bd.status === props.status);

  return item ? item.badge : statusBadges[0].badge;
};

export const getGuestCredentialStatus = guestCredentialStatusValue => {
  const item = statusGuestCredentials.find(
    st => Number(st.value) === Number(guestCredentialStatusValue),
  );

  return item ? item.label : statusGuestCredentials[0].label;
};

export const getGuestCredentialClass = guestCredentialStatusValue => {
  const item = statusGuestCredentials.find(
    st => Number(st.value) === Number(guestCredentialStatusValue),
  );

  return item ? item.class : statusGuestCredentials[0].class;
};

export const getAccommodationStatus = accommodationStatus => {
  if (accommodationStatus === undefined) return '';
  return accommodationStatus ? 'Confirmado' : 'Não confirmado';
};

export const getAccommodationClass = accommodationStatus => {
  if (accommodationStatus === undefined) return '';
  return accommodationStatus ? 'success' : 'danger';
};

export const getByPath = (object, path) => {
  if (!path) {
    return undefined;
  }

  return path
    .split('.')
    .reduce((acc, value) => (acc ? acc[value] : undefined), object);
};

/**
 * Aviso de impacto nas confirmações de exclusão dos cadastros que se relacionam
 * com filmes.
 *
 * As tabelas de ligação têm ON DELETE CASCADE, então excluir o cadastro remove
 * junto o vínculo com os filmes. Nenhum registro fica órfão, mas os filmes
 * perdem a informação — e isso precisa estar visível antes de confirmar.
 */
export function MoviesImpactWarning({ moviesCount = 0 }) {
  if (!moviesCount) {
    return null;
  }

  return (
    <p>
      <strong>Atenção:</strong> {moviesCount}{' '}
      {moviesCount === 1 ? 'filme será afetado' : 'filmes serão afetados'} por
      esta exclusão.
    </p>
  );
}

/**
 * Alerta da exclusao de Categorias.
 *
 * Aqui o aviso e diferente do usado em Diretores, Elenco e afins. Naqueles
 * cadastros o filme so perde o vinculo. Em Categorias a chave estrangeira
 * `movies.category_id` esta com ON DELETE CASCADE: apagar a categoria apaga
 * junto os filmes dela, e isso nao tem volta.
 */
export function CategoryMoviesDeleteWarning({ moviesCount = 0 }) {
  if (!moviesCount) {
    return null;
  }

  return (
    <p style={{ color: '#d33' }}>
      <strong>Atenção:</strong> {moviesCount}{' '}
      {moviesCount === 1
        ? 'filme será APAGADO junto'
        : 'filmes serão APAGADOS junto'}{' '}
      com esta exclusão. Essa operação não pode ser desfeita.
    </p>
  );
}

export const TOAST_OPTIONS = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

/**
 * Extrai uma mensagem legível de um erro do axios.
 *
 * A API às vezes devolve `message` como string e às vezes como o objeto de
 * erros do validador (ex.: {"field_value":["The field value field is
 * required."]}). Sem esse tratamento o objeto vaza cru para a tela.
 */
export const getApiErrorMessage = (err, fallback = 'Ocorreu um erro.') => {
  const message = err?.response?.data?.message;

  if (!message) {
    return fallback;
  }

  if (typeof message === 'string') {
    return message;
  }

  if (Array.isArray(message)) {
    return message.join(' ') || fallback;
  }

  if (typeof message === 'object') {
    const texts = Object.values(message).flat();
    const readable = texts.filter(Boolean).join(' ');

    return readable || fallback;
  }

  return fallback;
};

/**
 * Nome que cada campo obrigatório do filme tem na tela, para o aviso de
 * validação falar a língua de quem preenche o formulário e não o nome técnico
 * da coluna.
 */
export const movieRequiredFieldLabels = {
  category_id: 'Categoria',
  metragem_id: 'Metragem',
  genre_id: 'Gênero',
};

export const getMovieRequiredFieldsMessage = validationErrors => {
  const fields = Object.keys(validationErrors).map(
    field => movieRequiredFieldLabels[field] || field,
  );

  return `Preencha os campos obrigatórios: ${fields.join(', ')}.`;
};

/**
 * Rola a página até o campo que falhou na validação.
 *
 * `getElementById` sozinho não resolve: o react-dropdown-select, usado em todos
 * os Selects, não leva o atributo id para o HTML — só a classe. Nos selects a
 * busca então cai para o input escondido que ele cria com o name do campo.
 *
 * Campo em aba fechada tem a aba aberta antes da rolagem, e campo que não
 * existe na tela é ignorado em silêncio, sem interromper o resto do tratamento
 * do erro.
 */
export const scrollToFormField = fieldName => {
  const field =
    document.getElementById(fieldName) ||
    document.querySelector(`[name="${fieldName}"]`);

  if (!field) {
    return;
  }

  const tabPane = field.closest('.tab-pane');

  if (tabPane && !tabPane.classList.contains('active')) {
    document.querySelector(`a[href="#${tabPane.id}"]`)?.click();
  }

  const target = field.closest('.form-group') || field;

  // Dá tempo de a aba terminar de abrir antes de rolar.
  setTimeout(
    () => target.scrollIntoView({ behavior: 'smooth', block: 'center' }),
    150,
  );
};

/**
 * Nome da mostra para o CSV. Nas sessoes da Premiere Brasil — a mostra com
 * o campo premiere igual a 1 — o nome sai acompanhado da sub-mostra, no
 * formato "Premiere Brasil – Competicao Novos Rumos". As demais mostras, e
 * o filme da Premiere que ainda nao tem sub-mostra, saem so com o proprio
 * nome.
 */
export const getMovieShowsLabel = movie => {
  const premiereCategories = (movie.premiere_categories || [])
    .map(premiereCategory => premiereCategory.name)
    .filter(Boolean)
    .join(', ');

  return movie.shows
    .map(show =>
      Number(show.premiere) === 1 && premiereCategories
        ? `${show.name_pt} – ${premiereCategories}`
        : show.name_pt,
    )
    .join(', ');
};

// Tipo de credencial Imprensa (tabela credential_types da API). A categoria
// dessas credenciais é sempre a marcada como Imprensa (is_press), posta pela
// API; nos formulários o campo Categoria fica travado.
export const CREDENTIAL_TYPE_PRESS = 2;

// Origem da credencial (credential_guests.origin): 1 = inscrição pelo
// formulário público do site (hoje só a imprensa). Não é uma opção de
// Condição para escolher: só aparece na exibição.
export const CREDENTIAL_ORIGIN_SITE = 1;

// Item de Configurações Gerais da solicitação de ingressos pela imprensa: o
// único com máximo de sessões por pessoa (ticket_limit), uma por filme.
export const PRESS_TICKETS_FEATURE_KEY = 'credenciamento_imprensa_ingressos';

export const getCredentialCondition = credential => {
  if (Number(credential?.origin) === CREDENTIAL_ORIGIN_SITE) {
    return 'Inscrição pelo site';
  }

  return Number(credential?.is_companion) === 1 ? 'Acompanhante' : 'Convidado';
};
